'use strict';

var Field = require('./Field');

require('../../services/utils.service');

angular.module('dekky.forms.fields.uiSelect', ['dekky.forms.utils', 'ui.select'])
	.factory('UiSelectField', function($log, $q, formsUtils) {
		function uiSelectFactory(name, options, items) {
			function UiSelect(name, options, items) {
				if (!Array.isArray(items)) {
					throw new Error('Not items for uiSelect');
				}
				if (options.uiSelectOptions === undefined) {
					throw new Error('Not find uiSelect options');

				}

				this.type = 'uiSelect';
				this.items = items;
				this.uiSelectOptions = options.uiSelectOptions;

				Field.apply(this, arguments);
			}

			UiSelect.prototype = Object.create(Field.prototype);
			UiSelect.prototype.link = function(template) {
				var matchElement = template.find('ui-select-match'),
					choicesElement = template.find('ui-select-choices');
				matchElement.text(this.uiSelectOptions.matchTitle);
				choicesElement.text(this.uiSelectOptions.choicesTitle);

				if (this.uiSelectOptions.multiple) {
					template.attr('multiple', '');
				}

				if (angular.isDefined(this.uiSelectOptions.match)) {
					angular.forEach(this.uiSelectOptions.match, function(match, matchKey) {
						matchElement.attr(formsUtils.camelToDash(matchKey), match);
					});
				}

				if (angular.isDefined(this.uiSelectOptions.choices)) {
					angular.forEach(this.uiSelectOptions.choices, function(choice, choiceKey) {
						choicesElement.attr(formsUtils.camelToDash(choiceKey), choice);
					});
				}

				return $q.when(template);
			};

			return new UiSelect(name, options, items);
		}

		return uiSelectFactory;
	});